import React, { useContext, useMemo, useState } from "react"
import { useQuery } from "react-query"
import { getApprovedLoans } from "services/LoanService"
import FilterComp from "../FilterComp"
import { TableContainer } from "../style"
import { observer } from "mobx-react-lite"
import ApprovedLoanTable from "./ApprovedLoansTable"
import DownloadCSVBtn, { DisburseBtn } from "../AcctAcceptedLoans/DownloadCsvBtn"
import { usePaginate } from "hooks/usePagination"
import { APPROVED_COLUMNS } from "./appColumns"
import { Checkbox } from "antd"
import { AuthContext } from "context/AuthContext"
// import { AuthContext } from "context/AuthContext"



const AppLoansComp = () => {

	const {adminProfile} = useContext(AuthContext)
	const [selectedLoans,setSelectedLoans] = useState([])
	const {setLimit,setPage,page,limit} = usePaginate()
	const { data: res,isLoading,refetch } = useQuery(["approved-loans",page,limit], ()=>getApprovedLoans({page,limit}))
	const [searchQuery,setSearchQuery] = useState("")
	const data = useMemo(() => {
		const appLoans = res?.data?.loans ? res?.data?.loans : []
		return appLoans
	}, [res])

	const filteredData = useMemo(
		()=>data.filter(loan=>{
			const queryString = `${loan.applicant.first_name} ${loan.applicant.surname}`.toLowerCase()
			return queryString.includes(searchQuery.toLowerCase())
		}),
		[data,searchQuery]
	)

	const selectLoan = (id)=>{
		console.log(id)
		setSelectedLoans(prev=>{
			if(prev.includes(id)){
				return prev.filter(item=>item !== id)
			}
			return [...prev,id]
		})
	}

	const isAllSelected = useMemo(()=>(
		filteredData.every((item)=>selectedLoans.includes(item.id))
	),[selectedLoans,filteredData])

	const selectAllLoans = ()=>{
		if(!isAllSelected){
			setSelectedLoans(filteredData.map(loan=>loan.id))
		}else{
			setSelectedLoans([])
		}
	}

	 const ACC_APPROVED_COLUMNS = useMemo(() => {
        if (adminProfile.admin_role !== "acc") return APPROVED_COLUMNS;
        return [
            {
				title: "Pick", 
				render:(_,record)=>(
					<Checkbox 
						checked={selectedLoans.includes(record.id)} 
						onClick={()=>selectLoan(record.id)} 
					/> 
				)
			},
            ...APPROVED_COLUMNS
        ]
    }, [adminProfile,selectedLoans])

	return (
		<>
			<TableContainer>
				<header className="my-4 flex gap-x-4 items-center">
					<FilterComp filter={searchQuery} setFilter={setSearchQuery} />
					<div className="flex items-center gap-x-4 ml-auto">
						{adminProfile.admin_role === "acc" && (
							<>
							<DisburseBtn data={selectedLoans} refetch={refetch}/>
							<DownloadCSVBtn data={data} fileName="approved_loans"/>
							</>
						)}
					</div>
				</header>
				{
					adminProfile.admin_role === "acc" && (
						<header className="flex items-center gap-x-3 my-4">
							<Checkbox checked={isAllSelected} onClick={selectAllLoans}/>
							<button onClick={selectAllLoans}>Pick All</button>
						</header>
					)
				}
				<ApprovedLoanTable
					isLoading={isLoading}
					dataSource={filteredData}
					ACC_APPROVED_COLUMNS={ACC_APPROVED_COLUMNS}
				/>
			</TableContainer>
		</>
	)
}

export default observer(AppLoansComp)